import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Tooltip from "react-bootstrap/lib/Tooltip";

export const LOGGED_OUT_TEXT = "Connectez-vous pour pouvoir ajouter ce voyage à vos favoris.";

const WishlistToggle = (props) => {
  const renderToggle = (programmeId, isDisabled) => {
    return (
      <div
        data-track-stop-propagation="true"
        data-wishlist-programme-id={programmeId}
        className={cx("wishlist-toggle wishlist-toggle--js", {
          "wishlist-toggle--disabled": isDisabled,
        })}
      >
        <i
          className={cx("fa-heart", {
            fal: props.isInWishlist === false,
            fas: props.isInWishlist === true,
          })}
        />
      </div>
    );
  };

  return props.isLoggedOut ? (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={Math.random().toString(36).substring(7)}>{LOGGED_OUT_TEXT}</Tooltip>}
    >
      {renderToggle(props.programmeId, true)}
    </OverlayTrigger>
  ) : (
    renderToggle(props.programmeId, false)
  );
};

WishlistToggle.propTypes = {
  programmeId: PropTypes.string.isRequired,
  isLoggedOut: PropTypes.bool.isRequired,
  isInWishlist: PropTypes.bool.isRequired,
};

export default WishlistToggle;
